import { render, staticRenderFns } from "./DigitalReport.vue?vue&type=template&id=7e7870eb&scoped=true&"
import script from "./DigitalReport.vue?vue&type=script&lang=ts&"
export * from "./DigitalReport.vue?vue&type=script&lang=ts&"
import style0 from "./DigitalReport.vue?vue&type=style&index=0&id=7e7870eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7870eb",
  null
  
)

export default component.exports